module.exports = __webpack_public_path__ + "static/img/3.d7dc931.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/3.png
// module id = cIT+
// module chunks = 1